// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SZSFd","col":"styles_col__3DuqE","actions":"styles_actions__3MpVC","conflict":"styles_conflict__2q77f"};